import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";

export const useMarkConditionExtractionAsErroneous = ({
  patientId,
  amazonVisitId,
}: {
  patientId?: string;
  amazonVisitId?: string;
} = {}) => {
  const queryClient = useQueryClient();

  return useApiMutation<void, { questionnaireResponseId: string }>({
    mutationOptions: {
      mutationKey:
        QueryKeys.Patient.Chart.AmazonVisitIntake
          .MARK_CONDITION_EXTRACTION_AS_ERRONEOUS,
      mutationFn: async ({
        questionnaireResponseId,
      }: {
        questionnaireResponseId: string;
      }) => {
        await axiosInstance.put(
          `amazon-clinic/condition-extractions/${questionnaireResponseId}/marked-as-erroneous`,
        );
      },
      onSuccess: () => {
        if (patientId && amazonVisitId) {
          queryClient.invalidateQueries({
            queryKey: QueryKeys.Patient.Chart.AmazonVisitIntake.DEFAULT({
              patientId,
              amazonVisitId,
            }),
          });
        }
      },
    },
  });
};
